import { render, staticRenderFns } from "./warnningsList.vue?vue&type=template&id=b67afb0c&scoped=true"
import script from "./warnningsList.vue?vue&type=script&lang=js"
export * from "./warnningsList.vue?vue&type=script&lang=js"
import style0 from "./warnningsList.vue?vue&type=style&index=0&id=b67afb0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67afb0c",
  null
  
)

export default component.exports